<template>
    <div :class="['none-wrapper', fullScreen ? '' : 'non-stretch']">
        <resize-message :stickyHeight="stickyHeight" 
                        :messageHeight="100 / messages.length" 
                        class="none-message"
                        v-for="message in messages" 
                        :message="message" 
                        :pageMessageCount="messages.length">
        </resize-message>
    </div>
</template>

<script>
    import Vue from 'vue';
    import ResizeMessage from './resize-message';
    Vue.component('resize-message', ResizeMessage);
    export default {
        data() {
            return {

            }
        },
        props: {
            messages: {

            },
            stickyHeight: {

            },
            fullScreenDnb: {

            }
        },
        computed: {
            fullScreen() {
                console.log(this.messages[0]);
                return this.fullScreenDnb || (this.messages.length == 1 && this.messages[0].fullScreen)
            }
        }
    }



</script>
<style>
    .none-wrapper {
        height: 100%;
        width:100%;
    }

        .non-stretch {
            padding-bottom: 15px;
            padding-top: 15px;
            padding-left: 7rem;
            padding-right: 7rem;
        }

    /*@media only screen and (min-width: 1000px) and (orientation:portrait), screen and (min-width:1500px) and (orientation:landscape) {
        .none-wrapper {
            padding-left: 2rem !important;
            padding-right: 2rem !important;
        }
    }*/
</style>

